const apiConfig = {
  apiKey: process.env.REACT_APP_DRIVE_API_KEY,
  defaultFolder: process.env.REACT_APP_DEFAULT_FOLDER
};
export default {
  apiConfig
};